import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from "@angular/core";

@Component({
  selector: "app-response-formatter",
  templateUrl: "./response-formatter.component.html",
  styleUrls: ["./response-formatter.component.less"],
})
export class ResponseFormatterComponent implements OnInit, OnChanges {
  @Input() open: number;
  @Input() json: any;
  @Input() key: string;
  @Input() path: string;
  @Input() parentType: string;
  @Output() emitor = new EventEmitter<object>();

  isOpen: boolean;
  objectName: string;
  hasKey: boolean;
  parsedValue: string;
  type: string;
  value: any;
  isDate = false;
  isUrl = false;

  constructor() {}

  ngOnInit() {
    this.isOpen = this.open && this.open > 0;
    this.hasKey = typeof this.key !== undefined;
    this.setPath();
  }

  ngOnChanges() {
    this.setObjectName();
    this.initialiseProps();
    this.getValuePreview();
  }

  initialiseProps(): void {
    if (this.type === "string") {
      if (new Date(this.json).toString() !== "Invalid Date") {
        this.isDate = true;
      }
      if (null != this.json && this.json.indexOf("http") === 0) {
        this.isUrl = true;
      }
    }
  }

  setObjectName(): void {
    if (this.json === undefined) {
      this.objectName = "";
    } else if (this.json === null) {
      this.objectName = "Object";
    } else if (typeof this.json === "object" && !this.json.constructor) {
      this.objectName = "Object";
    } else {
      const funcNameRegex = /function (.{1,})\(/;
      const results = funcNameRegex.exec(this.json.constructor.toString());
      if (results && results.length > 1) {
        this.objectName = results[1];
      } else {
        this.objectName = "";
      }
    }
  }

  getValuePreview(): void {
    this.type = this.getType(this.json);
    if (this.type === "null" || this.type === "undefined") {
      this.value = this.type;
    } else if (this.type === "string") {
      this.value = '"' + this.escapeString(this.json) + '"';
    } else if (this.type === "function") {
      // Remove content of the function
      this.value =
        this.json
          .toString()
          .replace(/[\r\n]/g, "")
          .replace(/\{.*\}/, "") + "{…}";
    } else {
      this.value = this.json;
    }
  }

  getKeys(): Array<string> {
    if (this.isJsonObject() || this.isJsonArray()) {
      return Object.keys(this.json).map((key) => {
        if (key === "") {
          return '""';
        }
        return key;
      });
    }
    return [];
  }

  isJsonObject(): boolean {
    return Object.prototype.toString.apply(this.json) === "[object Object]";
  }

  isJsonArray(): boolean {
    return Array.isArray(this.json);
  }

  childrenOpen(): number {
    if (this.open > 1) {
      return this.open - 1;
    }
    return 0;
  }

  setPath() {
    if (this.key !== null) {
      if (!this.parentType) {
        this.path = "$";
      } else {
        if (this.parentType === "Array") {
          this.path = this.path + "[" + this.key + "]";
          // this.path = `${this.path}[${this.key}]`;
        } else if (this.parentType === "Object") {
          this.path = this.path + "." + this.key;
          // this.path = `${this.path}['${this.key}']`;
        }
      }
    }
  }

  addKeyToExtractor(key: string): void {
    const formatterVal = {
      key,
      value: this.path,
    };
    this.emitor.emit(formatterVal);
  }

  // Emiter per recursive component
  emitToParent(keyValuePair: object): void {
    this.emitor.emit(keyValuePair);
  }

  toggleOpen(): void {
    this.isOpen = !this.isOpen;
  }

  isEmptyObject(): boolean {
    const keys = this.getKeys();
    return keys && !keys.length && this.isOpen && !this.isJsonArray();
  }

  getType(object): string {
    if (object === null) {
      return "null";
    }
    return typeof object;
  }

  escapeString(str): string {
    return str.replace('"', '\"');
  }

  openLink(url: boolean): void {
    if (url) {
      window.location.href = this.json;
    }
  }
}
